import { useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useAuthenticatedFetch } from "../lib/api";
import { processFileResponse } from "../lib/file";

/**
 * responseCallback for the report file: hand it to the browser.
 *
 * A file the browser cannot save is logged and the read still succeeds, as
 * before. The `true` is there because React Query rejects an undefined query
 * result, which is why `isError` on `useAuthenticatedFileFetch` could not tell
 * a failed request from a successful download.
 */
async function downloadFile(res: Response): Promise<boolean> {
  await processFileResponse(res);
  return true;
}

/**
 * The report download page (doc-reports-and-report-batches-01a1883434685364,
 * R61 to R63). APP-2128 (DF-7): the window closes only after a successful read;
 * a failed read keeps it open and shows the texts of the bulk download failure
 * (R42). While the read runs, the page shows nothing.
 */
const ReportInfo = () => {
  const { reportId } = useParams();
  const url = `/reports/${reportId}`;

  const { isSuccess, isError } = useAuthenticatedFetch<boolean>(
    url,
    {},
    undefined,
    [url],
    downloadFile,
  );

  useEffect(() => {
    if (isSuccess) {
      window.close();
    }
  }, [isSuccess]);

  if (isError) {
    return (
      <Alert variant="danger">
        <Alert.Heading as="h1" className="h6">
          Failed to download reports
        </Alert.Heading>
        An error occurred
      </Alert>
    );
  }

  return null;
};

export default ReportInfo;
